import LoadingOverlay from '../../../../components/feedback/LoadingOverlay'
import PermissionError from '../../PermissionError'
import EntityFieldInputGroup from '../shared/EntityFieldInputGroup'
import PageLayout from '../shared/PageLayout'
import useEntityEdit from '../shared/useEntityEdit'
import { KindEditPageProps } from '../KindPages'
import computeLabel from '../shared/computeLabel'

const DefaultEditPage = ({
  entity,
  entityId,
  entityType,
  entityTypes,
  entityRepository,
  loading,
}: KindEditPageProps) => {
  const { fields, updateField, submitting, valid, submitEntity, deleteEntity, hasPermissions, permissionsLoading } =
    useEntityEdit({
      entity,
      entityId,
      entityType,
      entityRepository,
    })

  const loadingOverlayOpen = submitting

  if (!hasPermissions && !loading && !permissionsLoading) {
    return <PermissionError missingPermittedActions={[]} />
  }

  const label = computeLabel(entityType, fields)

  return (
    <>
      <PageLayout
        title={label ?? entityType.name}
        subtitle={label ? entityType.name : undefined}
        showCancel
        showSave
        showDelete={!!entity}
        saveDisabled={!valid}
        onSave={submitEntity}
        onDelete={deleteEntity}
      >
        <EntityFieldInputGroup
          entityType={entityType}
          entityTypes={entityTypes}
          fields={fields}
          updateField={updateField}
          loading={loading}
        />
      </PageLayout>
      <LoadingOverlay isOpen={loadingOverlayOpen} />
    </>
  )
}

export default DefaultEditPage
